import { Fit, Layout, Rive } from '@rive-app/canvas-lite'
import { onCleanup, onMount } from 'solid-js'
import heroRiv from '~/assets/anim/kv.riv?url'
import { m } from '~/paraglide/messages'
import { PlusBadge } from './plus-badge'

export function Hero() {
  let canvas!: HTMLCanvasElement // oxlint-disable-line eslint/no-unassigned-vars
  let rive: Rive

  onMount(() => {
    if (!canvas) return
    rive = new Rive({
      src: heroRiv,
      canvas,
      artboard: 'kv',
      autoplay: true,
      stateMachines: 'State Machine 1',
      layout: new Layout({ fit: Fit.FitHeight }),
      onLoad() {
        rive.resizeDrawingSurfaceToCanvas()
      },
    })
  })
  onCleanup(() => {
    rive?.cleanup()
  })

  return (
    <section class="flex w-full flex-col items-center gap-6">
      <PlusBadge />
      <h1
        class="px-4 text-center text-[26px] font-bold text-white"
        innerHTML={m
          .focus_pass_paywall_title({ plus_final_prize: m.land_skin_4_title() })
          .replace(
            'style="STYLE"',
            'class="hero-shine" style="color: #42FFFC;"',
          )}
      />

      <canvas ref={canvas} class="h-[20vh]" />
      <p class="text-center text-xs text-white/60">
        {m.focus_pass_paywall_caption()}
      </p>
    </section>
  )
}
